export * from 'server/models/PhoneNumber';


// WEBPACK FOOTER //
// ./data/models/PhoneNumber.ts